// Plugin to initialize site configuration
export default defineNuxtPlugin({
  name: 'config-init',
  dependsOn: ['pinia'],
  setup(nuxtApp) {
    // Initialize site store with local config if available
    const runtimeConfig = useRuntimeConfig()
    
    if (runtimeConfig.public.localConfig && Object.keys(runtimeConfig.public.localConfig).length > 0) {
      console.log('[config-init] Local config available:', runtimeConfig.public.localConfig)
      
      // Initialize site store with config data
      nuxtApp.hook('app:created', () => {
        try {
          const siteStore = useSiteStore()
          
          // Set manufacturer from config
          if (runtimeConfig.public.localConfig.manufacturer) {
            siteStore.manufacturer = runtimeConfig.public.localConfig.manufacturer
          }
          
          // Set other config properties if they exist
          Object.assign(siteStore, runtimeConfig.public.localConfig)
          
          console.log('[config-init] Site store initialized with local config')
          
        } catch (error) {
          console.error('[config-init] Error initializing site store:', error)
        }
      })
    } else {
      console.log('[config-init] No local config found, using defaults')
    }
  }
})
